/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Datetimebeforeaspect9Inputs */



/**

* @param {_Filter_Class_Datetimebeforeaspect9Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_datetimebeforeaspect9 = /** @type {((inputs?: _Filter_Class_Datetimebeforeaspect9Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Datetimebeforeaspect9Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("vor Datum")
});
export { _filter_class_datetimebeforeaspect9 as "_filter_class_DateTimeBEFOREAspect" }